<template>
<div style="background:#eee">
<v-app
      id="ui"
      class="pa-1"
      style="background:#eee"
      fluid
      app
      tag="section" 
    >
      <v-overlay
        :absolute="false"
        :opacity="0.45"
        :value="fetching_data"
        :z-index="3939938498494989"
      >
        <v-skeleton-loader
          :transition="'scale-transition'"
          height="94"
          width="350"
          type="list-item"
          class="loader"
        ></v-skeleton-loader>
      </v-overlay>

      <v-container id="dashboard" fluid tag="section">
        
        <v-tabs color="orange" v-model="tabs">
          <br />
          <v-tabs-slider></v-tabs-slider> 
          <v-tab href="#alerts" @click="page=1">
            <v-icon>mdi-alert-remove-outline</v-icon>
            <small class="px-3">Alerts</small>
          </v-tab> 
        </v-tabs>

        <v-sheet elevation="1" class="pa-4 mb-4 rounded-lg" color="white">
          <v-row align="center" dense> 
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="selected_asset"
                :items="all_assets"
                item-text="name"
                item-value="imei"
                label="Select Vehicle"
                prepend-inner-icon="mdi-car-connected"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-menu
                ref="menuFrom"
                v-model="menuu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="from_date"
                    label="From Date"
                    prepend-inner-icon="mdi-calendar-start"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="from_date" @input="menuu = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="3">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="To Date"
                    prepend-inner-icon="mdi-calendar-end"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="3" class="d-flex">
              <v-btn 
                color="blue" 
                dark 
                block 
                height="40"
                @click="available_data"
                :loading="fetching_data"
              >
                <v-icon left>mdi-magnify</v-icon>
                Search Records
              </v-btn>
            </v-col>

          </v-row>
        </v-sheet>
         
        <br>
        <v-tabs-items v-model="tabs" v-if="!fetching_data" style="background: #eee">  
          <v-tab-item  :value="'alerts'">
               <div v-if="!fetching_data &&   trip_data.length==0">
                <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
                    <div class="display-1  font-weight-light">No vehicle alert records available.</div> 
                    </v-alert>  
              </div> 

              <v-alert v-for="(drive,i) in filterrable(trip_data)" :key="i" border="left" color="red accent-4" colored-border  elevation="0" > 
              <div><v-icon>mdi-car</v-icon> <span class="px-3 display-1 font-weight-light">{{drive.desc}}   ({{drive.reg}}) </span> </div> 
              <div class="body-1  font-weight-light py-2"><v-icon>mdi-clock-time-two-outline</v-icon> <i class="px-2"></i>{{drive.dt_tracker}} </div> 
              <div class="body-1  font-weight-light"><v-icon>mdi-map-marker-distance</v-icon> <i class="px-2"></i>{{drive.current_loc}} </div> 
               <div class="row py-3 ml-0"> 
                <div cols="10" class="body-1  font-weight-light"><v-icon>mdi-speedometer</v-icon> <i class="px-2"></i>{{drive.speed +" kph"}}</div>
                <div cols="2" class="body-1  font-weight-light"> <v-btn class="ml-10" small outlined @click="loadClickedEvent(drive.event_id)"><small>View On Map</small></v-btn></div>
              </div>
              </v-alert> 
              <v-pagination v-model="page" v-if="trip_data.length>page_size" :length="round(trip_data.length/page_size)"></v-pagination>
            </v-tab-item>

              <v-tab-item :value="'map'"> 
                <div style="min-height: 300px">
                    <Map :tracking_data="tracking_data" />
                </div> 
          </v-tab-item> 
        </v-tabs-items>  
      </v-container>
</v-app>
</div>
</template>

<script>
import moment from "moment";
import { mapMutations, mapState } from "vuex";
import common from "../mixins/common";
import kensrin_map from "../mixins/kensrin_map";
import Map from "../account/Map"
import { searchAssets } from "@/services/assetsDb";

export default {
  name: "Alerts",
  mixins: [common ],
  components:{ Map },
  computed: {
    ...mapState(["notification", "session", "selected_object"])
  },
  data() {
    return {
      all_assets: [],
      selected_asset: "",
      top_dash: [],
      m_notification: [],
      trip_data: [],
      tracking_data: [],
      from_date: moment().subtract(1,'days').format("YYYY-MM-DD"),  //
      date: new Date().toISOString().substr(0, 10), 
      fetching_data: false,
      fetching_trip: false,
      page: 1, 
      page_size: 10,
      menu: false,
      menuu: false,
      modal: false,
      tabs: null, 
    };
  },
  created() {
    this.available_data();
  },
  async mounted() {  
    this.all_assets = await searchAssets(this.session.account[0].username);
  },
  methods: {
    loadClickedEvent(eventId){
      this.$store.dispatch("mark_event_read",eventId); 
      this.$router.push({
        name: 'EventDetail',
        params: { id: eventId },
        query:  { id: eventId  },
      })
    },
    filterrable(array){ 
      var new_array = [];  
      for(var i = this.page_size * (this.page -1); i < this.page * this.page_size; i++ ){
        if(i>=array.length)
          break;
        new_array.push(array[i]); 
      } 
      return new_array;
    },
    round(data){
      return Math.ceil(data);
    },
 
    showMap(data,source){  
      this.tracking_data = [];
      this.tracking_data.push({lat: data.lat,lng: data.lng,speed: data.speed,engineon: data.engineon,current_loc: data.current_loc,dt_tracker: data.dt_tracker });
      this.tabs ="map";
    }, 

    available_data() {   
      this.fetching_data = true;
      this.http_connect("/get_alerts", {
        token: this.check_token(),
        dtf: this.from_date +" 00:00:00",
        dtt: this.date + " 23:59:59",
        source: "report",
        imei: this.selected_asset 
      })
        .then(res => { 
          if (res.status == 200) {   
            this.trip_data = [];   
            let i=0;
            res.data.map(h=> {
                this.trip_data.push({event_id:h.event_id,lat: h.lat,lng: h.lng,speed: h.speed,engineon: true,current_loc: h.loc,dt_tracker: h.dt_tracker ,reg: h.name,desc: h.event_desc});
                if(i=0)
                console.log(h); 
                i++;
              });
            this.fetching_data = false;
            this.$store.dispatch("reset_last_event");  
            
          }
        })
        .catch(err => {
          console.log(err);
          
        });
    }
  }, 
};
</script>

<style scoped>
#dashboard,
template {
  background: #e7e7e7;
}
</style>
